// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zSHd","name":"Header_name__2PL4b","birthday":"Header_birthday__2NGrL","skeleton":"Header_skeleton__2VDhU"};